import './gridModal.scss';

import { CModal, CModalBody, CModalHeader } from '@coreui/react';
import React, { useEffect } from 'react';

import { GridList } from '../gridList/GridList';

interface ICurrencyModalProps {
  show: boolean;
  onClose: () => void;
  modalTitle: string;
  suggestedTitle: string;
  allTitle: string;
  items: React.ReactElement[];
  suggestedItems: React.ReactElement[];
}

export const GridModal: React.FC<ICurrencyModalProps> = ({
  show,
  onClose,
  modalTitle,
  allTitle,
  items,
  suggestedTitle,
  suggestedItems,
}) => {

  useEffect(() => {
    if (show) {
      document.body.classList.add('modal-open');

      /*
       * Only in the case we added the class we clean it up
       * this is to prevent removing the class if some other component added it
       */
      return () => {
        document.body.classList.remove('modal-open');
      };
    }
  }, [show]);

  return (
    <div>
      <CModal show={show} onClose={onClose} className="currency-language-modal">
        <CModalHeader className="curr-lang-modal-title">
          {modalTitle}
          <button type="button" className="close" onClick={onClose}>
            &times;
          </button>
        </CModalHeader>
        <CModalBody>
          <div className="result-container">
            <GridList
              title={suggestedTitle}
              items={suggestedItems}
            />
            <GridList
              title={allTitle}
              items={items}
            />
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};
